<template>
  <div v-if="mode() === 'default'" class="virtual-category-create">
    <div>
      <div class="virtual-category-create__level" v-for="n in level - 1" :key="n"></div>
    </div>
    <input
      v-model="value"
      type="text"
      ref="input"
      :placeholder="placeholder"
      class="virtual-category-create__input"
      @keypress.enter="submit"
    />
    <template v-if="value">
      <button type="button" @click="submit">
        <FontAwesomeIcon :icon="['fal', 'check-circle']" />
      </button>
      <button type="button" @click="reset">
        <FontAwesomeIcon :icon="['fal', 'times']" />
      </button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    level: {
      type: Number,
      default: 1,
    },
    scope: String,
  },
  inject: ['seperator', 'mode'],
  data() {
    return {
      value: null,
    }
  },
  methods: {
    submit() {
      this.$emit('create', [this.scope, this.value].filter(Boolean).join(this.seperator()))
      this.reset()
    },
    reset() {
      this.value = null
      this.$refs.input.blur()
    },
  },
}
</script>

<style lang="scss">
.virtual-category-create {
  display: flex;
  align-items: center;
  transition: background-color 200ms ease-out;
  padding: 1rem;

  &:hover {
    background-color: css-alpha('border-color', 0.3);
  }

  & > input {
    &:focus {
      outline: none;
    }
  }

  &__level {
    display: inline-block;
    opacity: 0.2;
    padding-right: 1rem;

    &:before {
      content: '∟';
      opacity: 0;
      transform: translateX(5px) translateY(-3px);
      display: inline-block;
    }

    &:last-child:before {
      opacity: 1;
    }
  }

  button {
    margin-right: 1rem;
    position: relative;
    cursor: pointer;
  }
}
</style>
